import { FilteredPrivateChatsContext } from "hhn-commons";
import * as React from "react";
import { useState } from "react";
import { GROUP_TYPE } from "@home-health-notify/domain";
import { ChatListSearchAndFilter } from "../ChatListSearchAndFilter";
import { PrivateChatListPanel } from "./PrivateChatListPanel";
import { PrivateChatListSearchView } from "./PrivateChatSearchSearchView";

interface PrivateChatsProps {
  selectedChatId?: string;
  unreadChatCount: number;
}

export const PrivateChats = ({
  selectedChatId,
  unreadChatCount,
}: PrivateChatsProps) => {
  const [searchMode, setSearchMode] = useState(false);

  const showSearchPanel = (): void => setSearchMode(true);

  const showChatListPanel = (): void => setSearchMode(false);

  const { fetchChats, resetChats } = React.useContext(
    FilteredPrivateChatsContext,
  );

  return (
    <>
      <ChatListSearchAndFilter
        showSearchPanel={showSearchPanel}
        showChatListPanel={showChatListPanel}
        groupType={GROUP_TYPE.PRIVATE}
        fetchChats={fetchChats}
        resetChats={resetChats}
      />
      {!searchMode ? (
        <PrivateChatListPanel
          selectedChatId={selectedChatId}
          unreadChatCount={unreadChatCount}
        />
      ) : (
        <PrivateChatListSearchView selectedChatId={selectedChatId} />
      )}
    </>
  );
};
